
const PartnershipCTA = () => {
  return (
    <section className="w-full bg-gradient-to-r from-teedee-blue via-bobo-green to-brand-purple text-white">
      <div className="w-full py-20 lg:py-24">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl lg:text-5xl font-bold mb-8">
            Interested in Partnering with Us?
          </h2>
          <p className="text-xl lg:text-2xl mb-10 opacity-90 leading-relaxed">
            Join our mission to provide quality educational content and positive community impact. Together, we can make a difference in children's lives!
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <a 
              href="/contact" 
              className="bg-white text-teedee-blue hover:bg-white/90 px-10 py-5 rounded-full font-semibold text-xl shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 inline-block"
            >
              Contact Us
            </a>
            <a 
              href="/about" 
              className="border-2 border-white text-white hover:bg-white hover:text-teedee-blue px-10 py-5 rounded-full font-semibold text-xl shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 inline-block"
            >
              Learn More
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnershipCTA;
